export default __webpack_public_path__ + "static/media/Blog3.8b3425a6.png";